import { render, staticRenderFns } from "./requImport2.vue?vue&type=template&id=5f2d8df6&scoped=true&"
import script from "./requImport2.vue?vue&type=script&lang=js&"
export * from "./requImport2.vue?vue&type=script&lang=js&"
import style0 from "./requImport2.vue?vue&type=style&index=0&id=5f2d8df6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d8df6",
  null
  
)

export default component.exports